var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.canShowBanner)?_c('div',{staticClass:"environment-banner",class:_vm.bannerData.class},[_c('i',{staticClass:"fa-light",class:_vm.bannerData.icon}),_c('span',{staticClass:"environment-words"},[_vm._v(_vm._s(_vm.environmentFriendlyText))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }